<script setup lang="ts">
import ProfileFields from '~/components/Unified/Profile/ProfileFields.vue';

const emit = defineEmits<{ verified: [] }>();
const open = defineModel<boolean>('open', { required: true });

const handleVerified = () => {
  emit('verified');
};
</script>

<template>
  <KUICoreDialog
    v-model="open"
    :heading="$t('unified.account.verifyDialog.heading')"
    alignment="center"
    content-width="full"
    has-overlay
  >
    <ProfileFields @verified="handleVerified" @saved="open = false" />
  </KUICoreDialog>
</template>
